import React from "react";
import PropTypes from "prop-types";

import * as DMConst from "../NonComponents/DMConst";
import { getNavOptionStr, isGlobalNavOptionBool, isNonGlobalNavOptionBool } from "../NonComponents/DMUtil";

import TComboBox from "../../../Library/ComboBoxes/TComboBox";

import * as Theme from "../../../App/Theme";

class DMNavComboBox extends React.Component {
    static propTypes = {
        height: PropTypes.number,

        navOption: PropTypes.number,
        onNavOptionChange: PropTypes.func,

        selectedCountryMstID: PropTypes.number,
        showGlobalOutputsBool: PropTypes.bool,
        showTargBySNU: PropTypes.bool,
    };

    static defaultProps = {
        height: 35,

        navOption: DMConst.introOp,
        onNavOptionChange: () => console.log("onNavOptionChange"),

        selectedCountryMstID: 0,
        showGlobalOutputsBool: false,
        showTargBySNU: false,
    };

    navComboBoxChange = (value, text, info) => {
        try {
            const props = this.props;
            const onNavOptionChange = props.onNavOptionChange;

            let navOptionByte = value + 1;

            onNavOptionChange(navOptionByte);
        } catch (exception) {
            alert(exception.name + ": " + exception.message);
        }
    };

    //==================================================================================================================
    //
    //                                                 Render
    //
    //==================================================================================================================

    render() {
        try {
            /* Props */
            const props = this.props;
            const showGlobalOutputsBool = props.showGlobalOutputsBool;
            const navOption = props.navOption;
            const selectedCountryMstID = props.selectedCountryMstID;
            const height = this.props.height;

            const comboBoxWidth = 525;

            let navOptionsStrArray = [];
            let navOptionsEnabledBoolArray = [];

            for (let i = 1; i <= DMConst.numNavOptions; i++) {
                //if(i===DMConst.targCovBySNUOp && (!this.props.showTargBySNU))
                //	continue;
                navOptionsStrArray.push(getNavOptionStr(i));

                /* Sample country has no dashboard */
                if (i === DMConst.targCovBySNUOp && !this.props.showTargBySNU) navOptionsEnabledBoolArray.push(false);
                else
                    navOptionsEnabledBoolArray.push(
                        ((isGlobalNavOptionBool(i) && showGlobalOutputsBool) ||
                            (isNonGlobalNavOptionBool(i) && !showGlobalOutputsBool)) &&
                            !(i === DMConst.countryDashOp && selectedCountryMstID === DMConst.countryCodeSampleCountry)
                    );
            }

            const navComboBox = (
                <TComboBox
                    onChange={this.navComboBoxChange}
                    enabledItems={navOptionsEnabledBoolArray}
                    itemIndex={navOption - 1}
                    items={navOptionsStrArray}
                    style={{
                        height: height,
                        width: comboBoxWidth,
                    }}
                />
            );

            return <div style={{ ...Theme.hCenteredStyle }}>{navComboBox}</div>;
        } catch (exception) {
            return (
                <div
                    className={"DMNavComboBoxDiv"}
                    key={"DMNavComboBoxDiv"}
                >
                    <h3 key={"DMNavComboBoxDivH3"}>{exception.name + ": " + exception.message}</h3>
                </div>
            );
        }
    }
}

export default DMNavComboBox;
